import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { makeStyles } from "@material-ui/core/styles";
import Slide from '@mui/material/Slide';

const OnlineUsersListModal = (props) => {
  const containerRef = React.useRef(null);
  const classes = useStyles();
  
  return (
    <Box>
      <Modal
        open={props.visible}
        onClose={() => {
            if (!props.persistent) {
              props.toggleModal(false);
            }
          }}
        ref={containerRef}  
      >
        <Slide direction="up" in={props.visible} container={containerRef.current}>
          <Box className={[classes.Modal,classes.scrollBar]} >
            <Typography sx={{ fontWeight: '800', fontSize: '1.4rem', mt: 2, mx: 2, '@media (min-width: 1636px)': { fontSize: '2rem' } }}>
              {props.title}
            </Typography>
            <hr />            
            <Box  sx={{ mt: 2, mx: 2 }}>
              {props.options &&
                props.options.map((data, ind) => {
                  return (
                    <Typography sx={{ fontWeight: '500', fontSize: '0.9rem', '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>
                        {data.userName}
                    </Typography>
                  );
                })
              }
              </Box>
          </Box>
        </Slide>
      </Modal>
    </Box>
  );
}
const useStyles = makeStyles({
  Modal: {
    position: 'absolute',
    top: '20%',
    left: '40%',
    height: '38vh',
    transform: 'translate(-50%, -50%)',
    width: 350,
    backgroundColor: '#DB8829',
    boxShadow: 24,
    color: '#FFFFFF',
    borderRadius: 30,
    padding: 20
    , '@media (min-width: 1636px)': { height: '50vh', width: 400, }
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#F5F5F5",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#CCC",
      borderRadius: 5,
    },
    overflow: "auto",
  },
})
export default OnlineUsersListModal;